import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useCreateStandardParagraphMutation } from "../../../services/clientreports";

const defaultValues = {
    typeId: null,
    name: ""
}

const useCreateStandardParagraph = (onHide) => {
    const [createTrigger, { isLoading: isCreating, ...createResult }] = useCreateStandardParagraphMutation();

    const form = useForm({ defaultValues });
    const { handleSubmit, reset } = form;

    const onClose = () => {
        reset();
        onHide();
    }

    const onCreate = (data) => {
        onClose();
        const { name } = data;
        return toast.promise(createTrigger(data).unwrap(), {
            loading: `Creating Standard Paragraph '${name}'`,
            success: `Created Standard Paragraph '${name}'`,
            error: `Failed to create Standard Paragraph '${name}'`
        })
    }

    return {
        onClose,
        onSubmit: handleSubmit(onCreate),
        ...form,
        isCreating,
        ...createResult
    }
}

export default useCreateStandardParagraph;